import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  inject,
} from '@angular/core';
import { SpinnerService } from '../../services/spinner.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SpinnerComponent {
  readonly spinnerService = inject(SpinnerService);
  private cdr = inject(ChangeDetectorRef);

  constructor() {
    effect(() => {
      this.spinnerService.loading();
      this.cdr.markForCheck();
    });
  }
}